module.exports = __webpack_public_path__ + "static/media/highlight-mobile.47a081aa.jpg";